import React, { useState, useEffect } from "react";
import GaugeComponent from "react-gauge-component";
import AOS from "aos";
import "aos/dist/aos.css";
import Web3 from "web3";
import Token from '../../abi/Ptgc.json';
import { sendGetRequest, providerURL } from '../../../../helper/Helper'; 

const ProjectedBurned = () => {
  const [burnBalance, setBurnBalance] = useState(0);
  const [todayBurn, setTodayBurn] = useState(0);
  const [value2, setValue2] = useState(calculateBurnedPercentage(burnBalance));
  const [activeTab2, setActiveTab2] = useState("1W");

  const handleTabClick2 = (tab) => {
    const valueMap = {
      "1W": parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 7))).toFixed(2),
      "1M": parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 30))).toFixed(2),
      "3M": parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 90))).toFixed(2), 
      "6M": parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 180))).toFixed(2), 
      "1Y": parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 365))).toFixed(2), 
      "5Y": parseFloat(calculateBurnedPercentage(burnBalance + (todayBurn * 365 * 5))).toFixed(2)
    };
    setActiveTab2(tab);
    setValue2(valueMap[tab]);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    getBurnData();
  }, []);

  useEffect(() => {
    handleTabClick2('1W');
  }, [burnBalance]);

  const getBurnData = async () => {
    const web3 = new Web3(providerURL());
    const pTGCContract = new web3.eth.Contract(Token.ABI, Token.Contract);
    setBurnBalance(parseInt(await pTGCContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18);
    
    try {
      const response = await sendGetRequest('historical/burn');
      if (response && response.status === 200 && response.data) {
        setTodayBurn(response.data['1Y'] / 365); 
      }
    } catch (error) {}
  };

  function calculateBurnedPercentage(burnedSupply) {
    const totalSupply = 333333333333;
    return (burnedSupply / totalSupply) * 100;
  }

  return (
    <div className="greysubcontent subcontent subPad">
      <div className="relative">
        <div className="row align-items-center justify-content-center text-center">
          <div className="col-xl-12">
            <h2 className='gradient-stroke-text' data-aos="fade-up"  data-aos-delay="1500" data-aos-duration="1400">Projected Burned</h2>
            <p data-aos="fade-up"  data-aos-delay="1700" data-aos-duration="1400">
              Estimate the number of PTGC expected to be burned based on current volume, fees, and activity trends.
            </p>

            <div className='d-flex justify-content-center '  data-aos="fade-up"  data-aos-delay="2000" data-aos-duration="1400">
              <div className="rTabs d-flex gap-1 mt-2 d-inline-block">
                {["1W", "1M", "3M", "6M", "1Y", "5Y"].map((tab) => (
                  <button key={tab} className={tab === activeTab2 ? "active" : ""} onClick={() => handleTabClick2(tab)}> {tab} </button>
                ))}
              </div>
            </div>
          </div>

          <div className="col-xl-12 text-center d-flex justify-content-center"  data-aos="fade-up"  data-aos-delay="1600" data-aos-duration="1400">
            <div className=' '>
              <GaugeComponent
                value={value2}
                type="radial"
                style={{ width: "450px", height: "365px" }}
                labels={{
                  tickLabels: {
                    type: "inner",
                    ticks: [
                      { value: 20 },
                      { value: 40 },
                      { value: 60 },
                      { value: 80 },
                      { value: 100 },
                    ],
                  },
                }}
                arc={{
                  colorArray: [
                    "#f9e79f",
                    "#ffcc00",
                    "#ffd700",
                    "#d4af37",
                  ],
                  subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
                  padding: 0.02,
                  width: 0.3,
                }}
                pointer={{
                  elastic: true,
                  animationDelay: 0,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectedBurned;
